export const SITE_URL = (process.env.REACT_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, "");
export const absUrl = (path) => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
